import * as R from 'ramda'
import { createSelector } from 'reselect'
import { entitySelector } from 'containers/Entity/selectors'

const approverStateSelector = state => state.approvals.approvers
const approverApprovalStateSelector = state => state.approvals.approverApprovals
const approverImageStateSelector = state => state.approvals.approverImages

const findBothIdAndRole = (id, role) => R.compose(
  R.find(
    R.where({
      userId: R.equals(id),
      role: R.equals(role)
    })
  ),
  R.values
)

const approversSelectorFunc = (entities, approverRefs, approvalRefs, imageRefs) => {
  // make sure to map multiple roles to 1 username
  // either get the substitute or approver
  const approvers = approvalRefs.reduce((result, id) => {
    const approverDetails = entities['workflow_approver_details']
    if (approverDetails && approverDetails[id]) {
      const {
        substituteId,
        role,
        approvalDate,
        action
      } = entities['workflow_approver_approvals'][id]

      const {
        email,
        name,
        username,
        userId,
      } = substituteId
        ? findBothIdAndRole(substituteId, role)(approverDetails)
        : approverDetails[id]

      const userPhoto = imageRefs.includes(username)
        ? entities['user_photos'][username]
        : {}

      const { image } = userPhoto
      const user = result[username]

      result[username] = user === undefined
        ? { id: userId, name, username, action, approvalDate, image, roles: [role] }
        : { id: userId, name, username, action, approvalDate, image, roles: R.uniq([...user.roles, role])}
    }
    return result
  }, {})
  return Object.values(approvers)
}

const approversSelector = createSelector(
  entitySelector,
  approverStateSelector,
  approverApprovalStateSelector,
  approverImageStateSelector,
  approversSelectorFunc
)

const usernameSelector = (state, id) => {
  const entities = entitySelector(state)
  const { username } = entities['workflow_approver_details'][id]
  return username
}

export {
  approversSelector,
  usernameSelector,
  approverImageStateSelector,
}
